module.exports = __webpack_public_path__ + "static/img/super-chat-pass-off.316c4517.png";